import { authStore } from './authstore';
import config from './config';
import { fetchUtils } from 'react-admin';

export default {
    login: ({ email }) => {
        const request = new Request(config.API_URL + '/user/login', {
            method: 'POST',
            body: JSON.stringify({ email }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        return fetch(request).finally(() => {
            throw new Error("Login request sent!");
        });
    },
    logout: () => {
        const token = authStore.get();
        if (!token)
            return Promise.resolve();
        const request = new Request(config.API_URL + '/user/logout', {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }),
        });
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(({ status }) => {
                if (status === 'ok')
                    authStore.remove();
                else
                    throw new Error("Logout not OK!");
            });
    },
    checkAuth: () => authStore.get() ? Promise.resolve() : Promise.reject(),
    checkError: error => {
        const status = error.status;
        if (status === 401 || status === 403) {
            authStore.remove();
            return Promise.reject();
        }
        return Promise.resolve();
    },
    getPermissions: () => {
        const token = authStore.get();
        if (!token)
            return Promise.reject();
        const jwtParts = token.split('.');
        if (!jwtParts || jwtParts.length !== 3)
            return Promise.reject();
        const payload = JSON.parse(atob(jwtParts[1]));
        if (!payload || !payload.scope)
            return Promise.reject();
        return Promise.resolve(payload.scope.split(" "));
    },
    getHttpClient: () => {
        return (url, options = {}) => {
            if (!options.headers) {
                options.headers = new Headers({ Accept: 'application/json' });
            }
            const token = authStore.get();
            if (token)
                options.headers.set('Authorization', `Bearer ${token}`);
            options.allowGetBody = true;
            return fetchUtils.fetchJson(url, options).then(({ headers, json }) => {
                const newToken = headers.get('x-token');
                if (newToken)
                    authStore.set(newToken);
                return { headers, json };
            });
        };
    }
};